
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit",
      function () {
        return require("private-next-pages/non-benefit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/non-benefit"])
      });
    }
  